module.exports = __webpack_public_path__ + "static/media/silicon1.83d89acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutme/slider/silicon1.png
// module id = 541
// module chunks = 0